<div class="container">
  <!-- section title -->
  <h2 class="section-title wow fadeInUp">Latest Updates</h2>

  <div class="spacer-60"></div>

  <div class="row blog-wrapper">
    <div class="col-md-4">
      <!-- blog item -->
      <div class="blog-item rounded bg-white shadow-dark wow fadeIn">
        <div class="thumb">
          <a href="javascript:">
            <span class="category">Licenses and Certifications</span>
          </a>
          <a href="javascript:" (click)="scrollTo('home')">
            <img src="assets/images/blog/1.svg" alt="blog-title" />
          </a>
        </div>
        <div class="details">
          <h4 class="my-0 title"><a href="https://www.linkedin.com/in/leslie-chihwai-284515170/details/certifications/">Agile Project Management</a></h4>
          <ul class="list-inline meta mb-0 mt-2">
            <li class="list-inline-item">June 2024</li>
            <li class="list-inline-item">LinkedIn</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="col-md-4">
      <!-- blog item -->
      <div class="blog-item rounded bg-white shadow-dark wow fadeIn">
        <div class="thumb">
          <a href="javascript:">
            <span class="category">Certification</span>
          </a>
          <a href="javascript:" (click)="scrollTo('home')">
            <img src="assets/images/blog/2.svg" alt="blog-title" />
          </a>
        </div>
        <div class="details">
          <h4 class="my-0 title"><a href="https://www.credly.com/badges/32754b0f-1e7c-457e-a5ba-b07a34fc86ac/public_url">Google UX Design Professional</a></h4>
          <ul class="list-inline meta mb-0 mt-2">
            <li class="list-inline-item">July, 2024</li>
            <li class="list-inline-item">Google</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="col-md-4">
      <!-- blog item -->
      <div class="blog-item rounded bg-white shadow-dark wow fadeIn">
        <div class="thumb">
          <a href="javascript:">
            <span class="category">Badge</span>
          </a>
          <a href="javascript:" (click)="scrollTo('home')">
            <img src="assets/images/blog/3.svg" alt="blog-title" />
          </a>
        </div>
        <div class="details">
          <h4 class="my-0 title"><a href="https://www.credly.com/badges/a757c182-03f5-4f7f-92c4-25af96d8a89e/public_url">AWS Cloud Quest Practioner </a></h4>
          <ul class="list-inline meta mb-0 mt-2">
            <li class="list-inline-item">July, 2024</li>
            <li class="list-inline-item">AWS</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
